const DAY_MS = 86_400_000;

export function parseLocalDate(value: string) {
  const [year, month, day] = value.split('-').map(Number);
  return new Date(year, Math.max(0, month - 1), day, 12, 0, 0, 0);
}

export function toLocalIsoDate(date: Date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function addLocalDays(value: string, days: number) {
  const date = parseLocalDate(value);
  date.setDate(date.getDate() + days);
  return toLocalIsoDate(date);
}

export function startOfSundayWeek(value: string) {
  const date = parseLocalDate(value);
  date.setDate(date.getDate() - date.getDay());
  return toLocalIsoDate(date);
}

export function endOfSaturdayWeek(value: string) {
  return addLocalDays(startOfSundayWeek(value), 6);
}

export function inclusiveDays(start: string, end: string) {
  return Math.max(1, Math.round((parseLocalDate(end).getTime() - parseLocalDate(start).getTime()) / DAY_MS) + 1);
}

export function weeksBetween(start: string, end: string) {
  return Math.max(1, Math.ceil(inclusiveDays(start, end) / 7));
}

export function endDateFromWeeks(start: string, weeks: number) {
  return addLocalDays(start, Math.max(1, weeks) * 7 - 1);
}

export function formatLocalDate(value: string) {
  return parseLocalDate(value).toLocaleDateString('pt-BR');
}

export function currentPlanWeek(start: string, today = toLocalIsoDate(new Date())) {
  if (today <= start) return 1;
  return Math.max(1, Math.floor((inclusiveDays(start, today) - 1) / 7) + 1);
}
